import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import misc from '../../misc';

class SessionList extends Component {
  render() {
    const currentYear = new Date().getYear();
    const renderedSessions = _.map(this.props.sessions, session => {
      const locale = 'en-NZ';
      // Date
      const startsAt = new Date(session.startsAt);
      let dateString = '';
      if (this.props.showDates === true) {
        const dateOptions = {
          weekday: 'long',
          month: 'short',
          day: 'numeric'
        };
        // Only show year if not the current year
        if (currentYear !== startsAt.getYear()) {
          dateOptions.year = 'numeric';
        }
        dateString = startsAt.toLocaleDateString(locale, dateOptions) + ' ';
      }
      // Time
      const timeOptions = {
        hour12: true,
        hour: 'numeric',
        minute: '2-digit'
      };
      const timeString = startsAt
        .toLocaleTimeString(locale, timeOptions)
        .toLowerCase()
        .replace(/ /g, '');
      // Render date & time
      const renderedDateAndTime = this.props.showDates ? (
        <React.Fragment>
          {dateString} {timeString}
          <br />
        </React.Fragment>
      ) : (
        `${timeString} `
      );
      // Location
      let locationName = 'Loading...';
      if (typeof this.props.allLocations[session.locationId] !== 'undefined') {
        locationName = this.props.allLocations[session.locationId].name;
      }
      // Clients
      let clientNames = _.map(session.clientIds, clientId => {
        if (typeof this.props.allClients[clientId] !== 'undefined') {
          const client = this.props.allClients[clientId];
          return `${client.firstName} ${client.lastName}`;
        } else {
          return 'Loading...';
        }
      });
      // Don't show client name line if only a single client and the same as currently active
      if (typeof this.props.activeClient !== 'undefined') {
        if (_.isEqual(session.clientIds, [this.props.activeClient.id])) {
          clientNames = [];
        }
      }
      const renderedClientNames =
        clientNames.length > 0 ? (
          <strong>
            {clientNames.join(', ')}
            <br />
          </strong>
        ) : (
          ''
        );
      // Repeats
      let repeatBadge = null;
      if (session.recurring && session.recurring.recurs) {
        repeatBadge = <div className="badge badge-secondary badge-pill">R</div>;
      }
      // Duration
      let durationLabel = null;
      switch (session.duration) {
        case 60:
          durationLabel = '1hr';
          break;
        default:
          durationLabel = `${session.duration}m`;
      }
      return (
        <misc.components.NavLinkSpan
          to={'/sessions/' + session.id}
          key={session.id}
          className="list-group-item d-flex
          justify-content-between align-items-center"
          linkClassName="list-group-item-action"
        >
          <span>
            {renderedDateAndTime}
            {renderedClientNames}
            <small className="text-muted">{locationName}</small>
          </span>
          <span className="text-center ml-1">
            <small>{durationLabel}</small>
            <br />
            {repeatBadge}
          </span>
        </misc.components.NavLinkSpan>
      );
    });

    return (
      <div className="list-group list-group-flush">{renderedSessions}</div>
    );
  }
}

SessionList.propTypes = {
  sessions: PropTypes.array.isRequired,
  allClients: PropTypes.object,
  allLocations: PropTypes.object.isRequired,
  activeClient: PropTypes.shape({
    id: PropTypes.string
  }),
  showDates: PropTypes.bool
};

SessionList.defaultProps = {
  showDates: false
};

export default SessionList;



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionList.js